import React from 'react';

import Help from './Help';
import BasketButton from '../Basket/BasketButton';
import StepsHeader, { StepsHeaderProps } from './StepsHeader';

const PageHeader: React.FC<StepsHeaderProps & { displayBasket?: boolean; hideHelp?: boolean; }> = ({
  currentIndex,
  length,
  title,
  onPrev,
  hideHelp,
  hideSteps,
  hidePrevButton,
  displayBasket,
}) => (
  <header className="w-full flex justify-between items-center z-30 px-6 kiosk:px-12 fixed bg-white/90 backdrop-blur-sm" id="header">
    <StepsHeader
      title={title}
      currentIndex={currentIndex}
      length={length}
      onPrev={onPrev}
      hideSteps={hideSteps}
      hidePrevButton={hidePrevButton}
    />
    <div className="flex items-center flex-1 justify-end">
      {displayBasket && <BasketButton />}
      {!hideHelp && <Help />}
    </div>
  </header>
);

export default PageHeader;
